import { render, staticRenderFns } from "./ImportarExportarCadastrosExport.vue?vue&type=template&id=6a45b1b9"
import script from "./ImportarExportarCadastrosExport.vue?vue&type=script&lang=js"
export * from "./ImportarExportarCadastrosExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports